import { distinctUntilArrayItemChanged, select } from '@ngneat/elf';
import { shareReplay, map, tap } from 'rxjs/operators';
import { systemStore } from './systemStore';

export const activeSystem$ = systemStore.pipe(
  select((state) => {
    return state.activeSystem;
  })
);

export const liveKPILastUpdatedTime$ = systemStore.pipe(
  select((state) => {
    return state.liveKPILastUpdatedTime;
  })
);


export const completedTelemetryExport$ = systemStore.pipe(
  select((state) => {
    return state.completedTelemetryExport;
  })
);

export const gqlSystems$ = systemStore.pipe(
  select((state) => {
    return state.gqlSystems;
  }),
  distinctUntilArrayItemChanged(),
  map((systems) =>
    systems.sort((a, b) =>
      a.sortOrder == b.sortOrder
        ? (a.name ?? '').localeCompare(b.name ?? '')
        : (a?.sortOrder ?? 0) < (b?.sortOrder ?? 0)
        ? -1
        : 1
    )
  ),
  shareReplay(1)
);
